import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { TextField, Label } from 'src/jbc-front/components/Form';
import { Pulldown } from 'jbc-front/components/icons';

import MoneyFieldMockup from './MoneyFieldMockup';

import styles from './EmployeePayForm.scss';

const PaymentsSectionMockup = ({ fields, isViewOnly, noLine, noEdit, name, greenTextList }) => {
  const [expandStates, setExpandStates] = useState({});
  const { t } = useTranslation();

  const toggleExpand = itemId => {
    setExpandStates(prev => ({
      ...prev,
      [itemId]: !prev[itemId]
    }));
  };

  const isExpanded = itemId => expandStates[itemId] || false;

  const recalculationHint = t('features.EmployeePays.components.PaymentsSectionMockup.recalculation_hint');

  return (
    <tbody>
      {fields.map((field, index) => (
        <React.Fragment key={`ps.${index + 1}`}>
          <tr className={(field.isTotal && !noLine) || field.id ? styles.total : ''}>
            <th className={classNames({ [styles.boldText]: field.description && greenTextList.includes(field.label) })}>{field.label}</th>
            <td className={styles.value}>
              {noEdit || isViewOnly || field.isTotal || field.description ? (
                <MoneyFieldMockup greenTextList={greenTextList} title={field.label} value={field.value} description={field.description} />
              ) : (
                <TextField name={`${name}[${index}].value`} textAlign="right" />
              )}
              {field.isHint && !isViewOnly && !noEdit && <Label note={recalculationHint} />}
            </td>
          </tr>
          {field.description &&
            field.description.length > 0 &&
            field.description.map((childField, childIndex) => {
              const childItemId = `${field.id}-${childIndex}`;
              return (
                <React.Fragment key={`ps.${childIndex + 1}`}>
                  <tr key={`psd.${childIndex + 1}`}>
                    <th style={{ paddingLeft: '20px' }}>
                      {childField.label}
                      {childField.isMotivationHint && (
                        <Label labelStyle={{ display: 'inline-block' }} note={t('features.EmployeePays.components.PaymentsSectionMockup.motivation_hint')} />
                      )}
                      {childField.description && (
                        <Pulldown
                          size={18}
                          className={isExpanded(childItemId) ? styles.expandIconOpen : styles.expandIconClose}
                          onClick={() => toggleExpand(childItemId)}
                        />
                      )}
                    </th>
                    <td className={styles.value}>
                      {noEdit || isViewOnly || childField.disabled ? (
                        <MoneyFieldMockup
                          greenTextList={greenTextList}
                          title={childField.label}
                          value={childField.value}
                          description={childField.description}
                        />
                      ) : (
                        <TextField name={`${name}[${index}].description[${childIndex}].value`} textAlign="right" />
                      )}
                      {childField.isHint && !isViewOnly && !noEdit && <Label note={recalculationHint} />}
                    </td>
                  </tr>
                  {isExpanded(childItemId) &&
                    childField.description &&
                    childField.description.map((grandChildField, grandChildIdx) => (
                      <tr key={grandChildField.id}>
                        <th style={{ paddingLeft: '40px' }}>{grandChildField.label}</th>
                        <td className={styles.value}>
                          {isViewOnly || grandChildField.disabled ? (
                            <MoneyFieldMockup greenTextList={greenTextList} title={grandChildField.label} value={grandChildField.value} />
                          ) : (
                            <TextField name={`${name}[${index}].description[${childIndex}].description[${grandChildIdx}].value`} textAlign="right" />
                          )}
                          {grandChildField.isHint && !isViewOnly && !noEdit && <Label note={recalculationHint} />}
                        </td>
                      </tr>
                    ))}
                </React.Fragment>
              );
            })}
        </React.Fragment>
      ))}
    </tbody>
  );
};
export default PaymentsSectionMockup;
